(function () {
    'use strict';

    angular
        .module('franchisee.components')
        .controller('ApplicationsListController', ApplicationsListController)

    /** @ngInject */
    function ApplicationsListController($rootScope, $scope, ApplicationService, AuthenticationService, HelperService, DATA_EVENTS) {
        const vm = this;

        vm.getImagePath = application => {
            return HelperService.imageHandlerPath('application', application.Id, application.Image);
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            init();
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function getApplications() {
            HelperService.startLoading('.applications-list-holder');

            const accessLevelId = AuthenticationService.getUserData().AccessLevel.Id;

            ApplicationService
                .getAllByAccessLevel(accessLevelId)
                .then(success => {
                    vm.applications = success;

                    HelperService.stopLoading('.applications-list-holder');
                }, error => {
                    HelperService.stopLoading('.applications-list-holder');
                    HelperService.errorCallback(error);
                })
        }

        function init() {
            getApplications();
        }
    }
}());